

































import { CreateElement, VNode } from 'vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Auth } from '@/kuroco_api/core/Auth';
import { TagCategoryStateModule } from '@/store';
import { TagModel } from '../../../type';

@Component<SlideMenu>({})
export default class SlideMenu extends Vue {
  // PROPS
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  shows!: boolean;

  // MUTATIONS
  get tagDefsForMenu() {
    const tagCategoryForMenu = TagCategoryStateModule.tagDefs.filter((tagDef) => tagDef.category_id === 4);
    if (tagCategoryForMenu.length === 0) {
      return [];
    }
    return tagCategoryForMenu[0].list;
  }

  // FIELDS
  TagCategoryStateModule = TagCategoryStateModule;

  // METHODS
  async logout(e: Event): Promise<void> {
    await Auth.logout({}).finally(() => {
      this.$router.push('/sub/login');
      this.$emit('update:shows', false);
    });
  }
  async execMenuFn(e: Event, tagDef: TagModel.Read.Response.List): Promise<void> {
    e.preventDefault();
    e.stopPropagation();
    this.$router.push({ name: 'search', query: { tag_id: `${tagDef.tag_id}` } });
    this.$emit('update:shows', false);
  }

  // LIFYCYCLE HOOKS
  mounted() {
    setTimeout((self: any) => (self.showState = 'block'), 250, this);
    TagCategoryStateModule.readAll();
  }
}

interface ISlideMenu {
  title: string;
  name: string;
}
